import api from './base'
import { endpoints } from './base'
import { Project } from '../../pages/projects/types'

/**
 * Получение списка проектов организации.
 * Second arg may be serverId (legacy) or options object (pagination/sort/filter).
 */
export type GetOrganizationProjectsOptions = {
  serverId?: number
  skip?: number
  limit?: number
  sort_by?: string
  sort_order?: string
}

export const getOrganizationProjects = async (
  organizationId: number,
  serverIdOrOptions?: number | GetOrganizationProjectsOptions,
): Promise<Project[]> => {
  try {
    const options: GetOrganizationProjectsOptions =
      typeof serverIdOrOptions === 'number' ? { serverId: serverIdOrOptions } : serverIdOrOptions || {}

    const params = new URLSearchParams()
    if (options.serverId != null) params.append('server_id', String(options.serverId))
    if (options.skip != null) params.append('skip', String(options.skip))
    if (options.limit != null) params.append('limit', String(options.limit))
    if (options.sort_by) {
      params.append('sort_by', options.sort_by)
      if (options.sort_order) params.append('sort_order', options.sort_order)
    }

    const query = params.toString()
    const url = query
      ? `${endpoints.organizationProjects.all(organizationId)}?${query}`
      : endpoints.organizationProjects.all(organizationId)
    const response = await api.get(url)
    return response.data
  } catch (error: any) {
    console.error('API Error getOrganizationProjects:', error.response || error)
    throw error
  }
}

/**
 * Получение деталей конкретного проекта
 */
export const getOrganizationProject = async (organizationId: number, projectId: number): Promise<Project> => {
  try {
    const response = await api.get(endpoints.organizationProjects.one(organizationId, projectId))
    return response.data
  } catch (error: any) {
    console.error('API Error getOrganizationProject:', error.response || error)
    throw error
  }
}

/**
 * Получение списка импортируемых проектов ODK
 */
export const getImportableOdkProjects = async (organizationId: number, serverId: number): Promise<Project[]> => {
  try {
    const response = await api.get(`/org/${organizationId}/odk-projects/importable-projects?server_id=${serverId}`)
    return response.data
  } catch (error: any) {
    console.error('API Error getImportableOdkProjects:', error.response || error)
    throw error
  }
}

/**
 * Импорт проекта ODK
 */
export const importOdkProject = async (
  organizationId: number,
  projectId: string | number,
  serverId: number,
): Promise<Project> => {
  try {
    const response = await api.post(`/org/${organizationId}/odk-projects/import-project`, {
      odk_project_id: projectId,
      server_id: serverId,
    })
    return response.data
  } catch (error: any) {
    console.error('API Error importOdkProject:', error.response || error)
    throw error
  }
}

/**
 * Получение списка импортируемых форм ODK
 */
export const getImportableOdkForms = async (organizationId: number, projectId: number): Promise<any[]> => {
  try {
    const response = await api.get(`/org/${organizationId}/odk-projects/${projectId}/import-forms`)
    return response.data
  } catch (error: any) {
    console.error('API Error getImportableOdkForms:', error.response || error)
    throw error
  }
}

/**
 * Импорт ODK формы
 */
export const importOdkForms = async (
  organizationId: number,
  projectId: number,
  formIds: string[],
): Promise<{ job_id: string; queued_forms: string[]; forms_total: number; next: string }> => {
  try {
    // Async import: backend returns 202 immediately, no timeout needed
    const response = await api.post(`/org/${organizationId}/odk-projects/${projectId}/import-forms`, formIds)
    return response.data
  } catch (error: any) {
    console.error('API Error importOdkForms:', error.response || error)
    throw error
  }
}

/**
 * Статус фоновой задачи импорта/синхронизации
 */
export const getImportJobStatus = async (jobId: string): Promise<any> => {
  try {
    const response = await api.get(`/sync-status/jobs/${jobId}`)
    return response.data
  } catch (error: any) {
    // With backend returning 200 + {status:'pending'}, any error is real now
    console.error('API Error getImportJobStatus:', error.response || error)
    throw error
  }
}
